const giftId = window.theme.freeGift.variantId;
const freeGiftLimit = window.theme.freeGift.limit;
const freeShippingLimit = window.theme.freeShipping.limit;
showProgressBarText(window.theme.subtotal);

function showProgressBarText(total) {
  let defaultMessage = document.querySelectorAll(".free-shipping-gift__default-message");
  if (defaultMessage.length == 0) {
    defaultMessage = document.querySelectorAll(".free-shipping__default-message");
  }

  const firstMessage = document.querySelectorAll(".free-shipping-gift__first-message");

  let successMessage = document.querySelectorAll(".free-shipping-gift__success-message");
  if (successMessage.length == 0) {
    successMessage = document.querySelectorAll(".free-shipping__success-message");
  }

  let successMessageFreeShipping = document.querySelectorAll(".free-shipping__success-message");
  if (successMessageFreeShipping.length == 0) {
    successMessageFreeShipping = document.querySelectorAll(".free-shipping__success-message");
  }

  // Hide all messages initially
  if (defaultMessage)
    defaultMessage.forEach((message) => {
      message.style.display = "none";
    });
  if (firstMessage)
    firstMessage.forEach((message) => {
      message.style.display = "none";
    });
  if (successMessage)
    successMessage.forEach((message) => {
      message.style.display = "none";
    });

  // Show the appropriate message based on the total
  if (total < freeShippingLimit) {
    if (defaultMessage)
      defaultMessage.forEach((message) => {
        message.style.display = "block";
      });
  } else if (total >= freeShippingLimit && total < freeGiftLimit) {
    if (firstMessage)
      firstMessage.forEach((message) => {
        message.style.display = "block";
      });
  } else if (total >= freeShippingLimit && !freeGiftLimit) {
    if (successMessageFreeShipping)
      successMessageFreeShipping.forEach((message) => {
        message.style.display = "block";
      });
  } else if (total >= freeGiftLimit) {
    if (successMessage)
      successMessage.forEach((message) => {
        message.style.display = "block";
      });
  }
}

document.addEventListener("theme:cart:change", async (event) => {
  const { total, items } = event.detail;
  const isFreeGiftRemoved = localStorage.getItem("freeGiftRemoved");

  showProgressBarText(total);

  if (!freeGiftLimit) return;

  if (isFreeGiftRemoved) {
    localStorage.removeItem("freeGiftRemoved");
    return;
  }

  let itemsArray = Array.from(items.children);

  const hasGift = itemsArray?.find((item) => {
    const variantId = +item.dataset.variantId;
    return variantId === giftId;
  });

  const totalCartWithoutGift = total - (hasGift?.dataset?.price || 0);

  const hasReachedFreeGiftLimit = totalCartWithoutGift > freeGiftLimit;
  if (hasReachedFreeGiftLimit && !hasGift) {
    await updateCart(1);
  }

  const hasNotReachedFreeGiftLimit = totalCartWithoutGift <= freeGiftLimit;
  if (hasNotReachedFreeGiftLimit && hasGift) {
    await updateCart(0);
  }
});

async function updateCart(quantity) {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [giftId]: quantity,
        },
      }),
    });

    // await response.json();

    document.dispatchEvent(
      new CustomEvent("theme:cart:drawer:update", {
        detail: {},
      })
    );
  } catch (error) {
    console.error("Error:", error);
  }
}
